import React, { useState, useEffect } from "react";
import { supabase } from "./supabaseClient"; // Supabase bağlantısı
import "./Announcements.css";

function Announcements() {
  const [announcements, setAnnouncements] = useState([]); // Duyuruları tutmak için state
  const [loading, setLoading] = useState(true); // Yükleme durumu
  const [error, setError] = useState(null); // Hataları izlemek için state
  const [currentPage, setCurrentPage] = useState(1); // Şu anki sayfa numarası
  const itemsPerPage = 4; // Sayfa başına duyuru sayısı

  useEffect(() => {
    const fetchAnnouncements = async () => {
      try {
        const { data, error } = await supabase
          .from("announcements")
          .select("*, announcement_images(img_url)")
          .order("created_at", { ascending: false });
    
        if (error) throw error;
    
        setAnnouncements(
          data.map((announcement) => ({
            ...announcement,
            img_urls: announcement.announcement_images.map((img) => img.img_url),
          }))
        );
        setLoading(false);
      } catch (err) {
        console.error("Duyurular yüklenirken hata oluştu:", err);
        setError("Duyurular yüklenemedi. Lütfen daha sonra tekrar deneyin.");
        setLoading(false);
      }
    };

    fetchAnnouncements();
  }, []);

  if (loading) {
    return <p>Yükleniyor...</p>;
  }

  if (error) {
    return <p>{error}</p>;
  }

  // Sayfalama işlevi
  const totalPages = Math.ceil(announcements.length / itemsPerPage);
  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  // Şu anki sayfada gösterilecek duyuruları hesapla
  const startIndex = (currentPage - 1) * itemsPerPage;
  const currentItems = announcements.slice(startIndex, startIndex + itemsPerPage);

  return (
    <div className="announcements">
      {currentItems.length && announcements && announcements.length > 0 ? (
        currentItems.map((announcement) => (
          <div key={announcement.id} className="announcement">
            <h1>{announcement.title || "Başlık Yok"}</h1>
            {/* Duyuru Görsellerini Göster */}
          <div className="image-list">
            {announcement.img_urls &&
              announcement.img_urls.map((img, index) => (
                <img
                  key={index}
                  src={img}
                  alt={`Duyuru Görsel ${index + 1}`}
                  className="announcement-image"
                />
              ))}
          </div>
            {/* dangerouslySetInnerHTML ile açıklamayı işleme */}
            <div
              className="announcement-description"
              dangerouslySetInnerHTML={{
                __html: announcement.description || "Açıklama Yok",
              }}
            ></div>
            <p className="announcement-date">
              {announcement.created_at
                ? `Yayınlanma Tarihi: ${new Date(announcement.created_at).toLocaleDateString()}`
                : "Tarih Bilgisi Yok"}
            </p>
          </div>
        ))
      ) : (
        <p className="announcement-date">Henüz duyuru bulunmamaktadır.</p>
      )}

      {/* Sayfalama Butonları */}
      <div className="pagination">
        {Array.from({ length: totalPages }, (_, index) => (
          <button
            key={index + 1}
            className={`page-btn ${currentPage === index + 1 ? "active" : ""}`}
            onClick={() => paginate(index + 1)}
          >
            {index + 1}
          </button>
        ))}
      </div>
    </div>
  );
}

export default Announcements;
